const QuestionLabel: React.FC<{ question: string }> = ({ question }) => {
  return (
    <div className="text-lg font-gilroy text-[18px] font-semibold text-start">
      {question}
    </div>
  );
};

export default QuestionLabel;
